import React from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../Context/authContext';
import { UtiProvider } from "../Context/utiContext";

import LayoutAreaAdmin from '../Pages/Components/LayoutAreaAdmin';
import PrivateRoute from './privateRoute';

import ScrollToTop from '../scrollToTop';

import Index from '../Pages/Index/index';
import Login from '../Pages/Login/index';
import Equipe from '../Pages/Equipe/index';
import Sobre from '../Pages/Sobre/index';
import Treinamentos from '../Pages/Treinamentos/index';
import Conteudos from '../Pages/Conteudos/index';
import VisualizadorArquivo from '../Pages/Conteudos/visualizadorArquivo';

import CadastroConteudo from '../Pages/CadastroConteudoArquivos';
import ListarConteudos from '../Pages/CadListaConteudos';
import EditarConteudo from '../Pages/EditarArquivos'; // criar esta página para editar e listar arquivos

const routeNames = {
    index: '/',
    sobre: '/Sobre',
    equipe: '/Equipe',
    treinamentos: '/Treinamentos/:tipo?',
    conteudos: '/conteudo/:conteudoID',
    visualizar: 'arquivo/:arquivoID',
    login: '/Login',
    cadastroConteudo: '/admin/cadastrar-conteudo/:conteudoID?',
    listarConteudos: '/admin/listar-conteudo',
    editarConteudo: '/admin/editar-conteudo/:conteudoID'
};

const Rotas = () => {
    return (
        <AuthProvider>
            <UtiProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        {/* ROTAS PÚBLICAS */}
                        <Route path={routeNames.index} element={<Index />} />
                        <Route path={routeNames.login} element={<Login />} />
                        <Route path={routeNames.equipe} element={<Equipe />} />
                        <Route path={routeNames.sobre} element={<Sobre />} />
                        <Route path={routeNames.treinamentos} element={<Treinamentos />} />
                        <Route path={routeNames.conteudos} element={<Conteudos />}>
                            <Route path={routeNames.visualizar} element={<VisualizadorArquivo />} />
                        </Route>

                        {/* ROTAS PRIVADAS */}
                        <Route element={<PrivateRoute><LayoutAreaAdmin /></PrivateRoute>}>
                            <Route path={routeNames.cadastroConteudo} element={<CadastroConteudo />} />
                            <Route path={routeNames.listarConteudos} element={<ListarConteudos />} />
                            <Route path={routeNames.editarConteudo} element={<EditarConteudo />} />
                        </Route>

                        {/* Rota fallback */}
                        <Route path="*" element={<Index />} />
                    </Routes>
                </BrowserRouter>
            </UtiProvider>
        </AuthProvider>
    );
};

export default Rotas;
